export const getWarehouse = (state, warehouse) => {
  state.warehouse = warehouse
}

export const setLoading = (state, value) => {
  state.loading = value;
} 
